import { useQuery } from '@tanstack/react-query';

import { getComments } from './utils/requests';

export const useFileComments = ({
  fileId,
  userId,
  queryKey,
  railsType,
  showReactions = true,
}) =>
  useQuery({
    queryKey: [queryKey, fileId],
    queryFn: () => getComments({ fileId, userId, railsType }),
    enabled: !!fileId && !!userId && !!railsType && showReactions,
    staleTime: Infinity,
  });
